module.exports = __webpack_public_path__ + "img/choice-hacking.bf6124b.png";